import jQuery from 'jquery';
import { BookmakersHandler } from 'rp-prices-component';

import * as segmentio from 'rp-analytics';
import { analyticsPage } from '../analyticsPage';

import deviceDetect from './deviceDetect';
import cardPage from './cardPage';
import { skybetDiffusionName } from '../helpers/utils';

const messageSelectedClass = 'RC-chooseBookieMobile__message--selected';
const popoverSelectedClass = 'RC-chooseBookieMobile--selected';
const bookmakerSelector = '.js-RC-chooseBookieMobile__bookmaker';
const bookmakerSelectedSelector = '.RC-chooseBookieMobile__bookmaker--selected';
const bookmakerSelectedClass = 'RC-chooseBookieMobile__bookmaker--selected';
const buttonSelector = '.js-RC-chooseBookieMobile__button';
const logInSelector = '.js-RC-chooseBookieMobile__accountBtn--logIn';
const registerSelector = '.js-RC-chooseBookieMobile__accountBtn--register';
const linkSelector = '.js-RC-chooseBookieMobile__link';
const overlayClass = 'RC-chooseBookieMobile__overlay';

const configBookieNames = {
    WH_OXI: 'William Hill',
    LADB: 'Ladbrokes',
    PPWR: 'Paddy Power',
    BETFAIR: 'Betfair',
    CORAL: 'Coral',
    [skybetDiffusionName]: 'SkyBet',
    BET365: 'bet365',
};

const BEST_ODDS = '#BESTODDS';

export default class ChooseBookie {
    constructor(isOnLoad) {
        this.$template = jQuery('.js-RC-chooseBookieMobile');
        this.$messageSpecific = jQuery('.js-RC-chooseBookieMobile__message--specific');
        this.isOnLoad = isOnLoad;
        this.eventsAreBound = false;
        this.bindEvents = this.bindEvents.bind(this);
    }

    init() {
        if (!deviceDetect.phone() || (this.isOnLoad && jQuery.cookie('chooseBookie'))) {
            this.$template.remove();
            return jQuery.Deferred().resolve();
        }

        this.bindEvents(false);
        const deferred = jQuery.Deferred();
        this.resolvePromise = deferred.resolve;
        if (!this.isOnLoad) {
            this.resolvePromise();
        }
        return deferred.promise();
    }

    bindEvents(isCalledExternally) {
        if (this.isOnLoad || isCalledExternally) {
            this.showLightbox();
        }

        if (!this.eventsAreBound) {
            // eslint-disable-next-line array-callback-return
            jQuery(registerSelector).map((_, element) => {
                const bookmakerRegisterLink = element.getAttribute('href');

                if (!bookmakerRegisterLink.includes('/redirect/')) {
                    const bookmakerName = element.getAttribute('bookmaker-name');
                    const bookmakerRedirectUrl =
                        `/redirect/?url=${encodeURIComponent(bookmakerRegisterLink)}&name=${bookmakerName}`;
                    element.setAttribute('href', bookmakerRedirectUrl);
                }
            });

            this.$template
                .on('click', buttonSelector, this.onButtonClick.bind(this))
                .on('click', logInSelector, this.logInBookieHandler.bind(this))
                .on('click', registerSelector, this.registerBookieHandler.bind(this))
                .on('click', linkSelector, this.closeModal.bind(this));
            this.eventsAreBound = true;
        }
    }

    showLightbox() {
        const config = {
            cssClass: 'RC-modal_chooseBookieMobile',
            showClose: false,
            autoClose: false,
            overlayCssClass: overlayClass,
        };
        const $overlayNode = jQuery(`.${overlayClass}`);
        const $selectedBookmaker = this.getSelectedBookmakerNode();

        analyticsPage({ 'Choose Your Bookie': 'true' });
        cardPage.removeScroll();

        if (!this.isOnLoad && $selectedBookmaker[0]) {
            this.selectBookmaker($selectedBookmaker);
        }

        if ($overlayNode[0]) {
            $overlayNode.show();
        } else {
            this.$template.rpModalBox(config);
        }

        /* eslint-disable-next-line no-unused-vars */
        const bookmakersHandler = new BookmakersHandler();
    }

    getSelectedBookmakerNode() {
        const feedName = jQuery.cookie('chooseBookie');

        if (feedName) {
            return jQuery(`${bookmakerSelector}[data-feed="${feedName}"]`);
        }

        return false;
    }

    selectBookmaker($bookmakerChosen) {
        const bookmakerName = $bookmakerChosen.attr('data-bookmaker-name');
        const $bookmakerChosenMessage = jQuery(`.js-RC-chooseBookieMobile__message--${bookmakerName}`);

        if ($bookmakerChosen[0].classList.contains(bookmakerSelectedClass)) {
            return;
        }

        if (!this.$template[0].classList.contains(popoverSelectedClass)) {
            this.$template
                .on('click', linkSelector, this.chooseBookieHandler.bind(this));
            this.$template
                .addClass(popoverSelectedClass);
        }

        jQuery(bookmakerSelector).removeClass(bookmakerSelectedClass);
        this.$messageSpecific.removeClass(messageSelectedClass);
        $bookmakerChosenMessage.addClass(messageSelectedClass);
        $bookmakerChosen.addClass(bookmakerSelectedClass);
    }

    getBookmakerAnalyticsDetails(bookmaker) {
        const bookmakerFeed = bookmaker.getAttribute('data-feed');

        return {
            bookmakerName: configBookieNames[bookmakerFeed],
            bookmakerPosition: Number(bookmaker.getAttribute('data-position')),
        };
    }

    onButtonClick(event) {
        const bookmakerChosen = jQuery(event.target).closest(bookmakerSelector);
        this.selectBookmaker(bookmakerChosen);

        const {
            bookmakerName,
            bookmakerPosition
        } = this.getBookmakerAnalyticsDetails(bookmakerChosen[0]);

        segmentio.trackOfferAccordion({
            [segmentio.TRAIT_BOOKMAKER_NAME]: bookmakerName,
            [segmentio.TRAIT_OFFERS_BANNER]: 'Choose your Bookmaker',
            [segmentio.TRAIT_POSITION]: bookmakerPosition,
        });
    }

    chooseBookieHandler() {
        const feedName = jQuery(bookmakerSelectedSelector).attr('data-feed');

        if (feedName) {
            jQuery.cookie('chooseBookie', feedName, {
                domain: `.${location.host.split('.').slice(1).join('.')}`,
                path: '/',
                expires: 365
            });

            if (!this.isOnLoad) {
                const betslipEvent = new CustomEvent('BETSLIP.BOOKMAKER.SET', {
                    detail: { bookmaker: feedName },
                });
                document.dispatchEvent(betslipEvent);
            }
        }

        this.resolvePromise(feedName);
    }

    closeModal() {
        cardPage.addScroll();

        jQuery.cookie('chooseBookie', BEST_ODDS, {
            domain: `.${location.host.split('.').slice(1).join('.')}`,
            path: '/',
            expires: 365
        });

        if (this.isOnLoad) {
            this.$template.rpModalBox('close');
            const betslipEvent = new CustomEvent('BETSLIP.BOOKMAKER.SET', {
                detail: { bookmaker: BEST_ODDS },
            });
            document.dispatchEvent(betslipEvent);
        } else {
            jQuery(`.${overlayClass}`).hide();

            const betslipEvent = new CustomEvent('BETSLIP.BOOKMAKER.SET', {
                detail: { bookmaker: BEST_ODDS },
            });
            document.dispatchEvent(betslipEvent);
        }

        this.resolvePromise(BEST_ODDS);
    }

    logInBookieHandler() {
        this.chooseBookieHandler();
    }

    registerBookieHandler(event) {
        const bookmakerChosen = jQuery(event.target).closest(bookmakerSelector);
        const {
            bookmakerName,
            bookmakerPosition
        } = this.getBookmakerAnalyticsDetails(bookmakerChosen[0]);

        segmentio.trackBookmakerRegistrationTap({
            [segmentio.TRAIT_BOOKMAKER_NAME]: bookmakerName,
            [segmentio.TRAIT_OFFERS_BANNER]: 'Choose your Bookmaker',
            [segmentio.TRAIT_POSITION]: bookmakerPosition,
        });
    }
}



// WEBPACK FOOTER //
// ./lib/js/modules/chooseBookie.js